import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetData,
  type GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetError,
  type GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetResponse,
  getRetailersForOrganizationV1OrganizationsOrgIdRetailersGet,
} from '../../generated';

export type GetRetailersForOrganizationQueryVariables =
  GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetData['path'];

export type GetRetailersForOrganizationQuery = GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetResponse;

export const useGetRetailersForOrganizationQuery = <
  TData = GetRetailersForOrganizationQuery,
  TError = GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetError,
>(
  { org_id }: GetRetailersForOrganizationQueryVariables,
  options?: Omit<UseQueryOptions<GetRetailersForOrganizationQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<GetRetailersForOrganizationQuery, TError, TData>({
    queryKey: ['GetRetailersForOrganization', { org_id }],
    queryFn: async () => {
      const { data } = await getRetailersForOrganizationV1OrganizationsOrgIdRetailersGet({
        path: { org_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useGetRetailersForOrganizationQuery.getKey = ({ org_id }: GetRetailersForOrganizationQueryVariables) => [
  'GetRetailersForOrganization',
  { org_id },
];

useGetRetailersForOrganizationQuery.fetcher = (
  { org_id }: GetRetailersForOrganizationQueryVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await getRetailersForOrganizationV1OrganizationsOrgIdRetailersGet({
      path: { org_id },
      throwOnError: true,
    });
    return data;
  };
};
